var poll_header_default = {
  "title": "jUEp7",
  "image": "QbdA9",
  "webview": "nhLMs"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
